import React from 'react';
import { Zoom } from 'react-awesome-reveal';
// import me from '../../images/me.jpg';

function Skills() {
  return (
    <div id="skillsSection" className="skills">
      <div className="skills-div">
        <h1 className="skills-text">A few of the tools and technologies I am familiar with are</h1>
        <div className="skills-images-div">
          <Zoom>
            <img className="skills-images" alt="HTML5" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="CSS3" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Bootstrap" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/bootstrap/bootstrap.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="JavaScript" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Python" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/python/python.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="React" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Redux" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/redux/redux.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Express" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/express/express.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Node.js" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="MongoDB" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/mongodb/mongodb.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="GraphQL" src="https://raw.githubusercontent.com/github/explore/5c058a388828bb5fde0bcafd4bc867b5bb3f26f3/topics/graphql/graphql.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="Git" src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/git/git.png" />
          </Zoom>
          <Zoom>
            <img className="skills-images" alt="GitHub" src="https://raw.githubusercontent.com/github/explore/78df643247d429f6cc873026c0622819ad797942/topics/github/github.png" />
          </Zoom>
        </div>
        <h2 className="skills-desc">As is probably apparent, JavaScript is my strong suit - most of the development work I have done has been in JavaScript. However, Python is my go-to language for competitive coding.</h2>
      </div>
    </div>
  )
}

export default Skills;